export default function featureEnabled (user, featureName) {
  const features = user.get('features') || {}
  return !!features[featureName]
}
